var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_663_3396)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.412598,
    y: 0.678711,
    width: 37.3625,
    height: 37.3625,
    rx: 9.34062,
    fill: "#6AD5FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pattern"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 13",
    cx: 5.66492,
    cy: 14.7511,
    r: 27.7137,
    transform: "rotate(-0.403168 5.66492 14.7511)",
    fill: "url(#paint0_linear_663_3396)",
    stroke: "url(#paint1_linear_663_3396)",
    strokeWidth: 0.0572801
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 11",
    cx: 19.1547,
    cy: 34.5553,
    r: 27.7137,
    transform: "rotate(-0.403168 19.1547 34.5553)",
    fill: "url(#paint2_linear_663_3396)",
    stroke: "url(#paint3_radial_663_3396)",
    strokeWidth: 0.0572801
  })), /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/flag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7153 7.12842V31.592",
    stroke: "white",
    strokeWidth: 1.33438,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.7153 9.57446H24.4149C27.7175 9.57446 28.4514 11.4092 26.1274 13.7333L24.6596 15.2011C23.681 16.1796 23.681 17.7697 24.6596 18.626L26.1274 20.0938C28.4514 22.4178 27.5952 24.2526 24.4149 24.2526H10.7153",
    stroke: "white",
    strokeWidth: 1.33438,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_663_3396",
    x1: 5.66492,
    y1: -12.9913,
    x2: 5.66492,
    y2: 42.4934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_663_3396",
    x1: 34.7222,
    y1: 11.9929,
    x2: -29.5502,
    y2: 26.2329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2388FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2388FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_663_3396",
    x1: 19.1547,
    y1: 6.81289,
    x2: 19.1547,
    y2: 62.2976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2948A7",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2948A7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_663_3396",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.1547 34.5553) rotate(89.968) scale(57.4732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#7FC5FF",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FC5FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_663_3396"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.412598,
    y: 0.678711,
    width: 37.3625,
    height: 37.3625,
    rx: 9.34062,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSquare);
export default __webpack_public_path__ + "static/media/flagSquare.8e3ddfed2a80be97286c6c5cd8e26fcc.svg";
export { ForwardRef as ReactComponent };